import React, { useEffect, useMemo } from 'react';
import {
  Button, Col, Form, Row,
} from 'react-bootstrap';
import { NavLink, useParams } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { years } from '../../../../helpers';
import style from './TabResults.module.less';
import { dateRenderer } from '../../../../services/formatSvc';
import DownloadLink from '../../../common/DownloadLink';
import useUserContext from '../../../../hooks/useUserContext';
import { status, statusForFilter, statusForFilterRu } from '../../../../helpers/StrategyProject/stratProjectHelpers';
import { isAdmin, isStratAdmin } from '../../../../services/rolesSvc';
import { getPathType, getProjectTypeText } from '../../../../helpers/typeProject';

function ResultsHeader({
  resultPeriod, store, projectId, requests, childProjects, setProjectsFilter, selectedProjects, setAllTablesOpen, type,
}) {
  const userCtx = useUserContext();
  const { stratId } = useParams();
  const optionsResultStatus = Object.entries(statusForFilterRu).map((val, index) => ({ value: val[1], label: val[0] }));
  const optionsResultsYear = [{ value: 'null', label: 'Не указан' }, ...years.map((val, index) => ({ value: val, label: val }))];
  const projectsOptions = useMemo(() => childProjects.map((proj) => ({ label: `${proj.fullNumber} ${proj.name}`, value: proj })), [childProjects]);

  return (
    <div
      className={style.filterRow}
    >
      <Form.Group xs="2" className={style.tooltipSelectField}>
        <Form.Label style={{ fontSize: '14px', fontWeight: 600 }}>
          Год результатов
        </Form.Label>
        <AsyncSelect
          noOptionsMessage={() => 'Ничего не найдено'}
          loadingMessage={() => 'Поиск...'}
          defaultValue={optionsResultsYear[0]}
          defaultOptions={optionsResultsYear}
          menuPortalTarget={document.body}
          isDisabled={!!store.strategies.filters.dateMilestones}
          value={!store.strategies.filters.dateResults
            ? optionsResultsYear[0]
            : { value: store.strategies.filters.dateResults, label: store.strategies.filters.dateResults }}
          onChange={(e) => { store.strategies.changeFilter('dateResults', e.value, requests); }}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 100 }),
          }}
        />
      </Form.Group>
      <Form.Group xs="2" className={style.tooltipSelectField}>
        <Form.Label style={{ fontSize: '14px', fontWeight: 600 }}>
          Год вех
        </Form.Label>
        <AsyncSelect
          noOptionsMessage={() => 'Ничего не найдено'}
          loadingMessage={() => 'Поиск...'}
          defaultValue={optionsResultsYear[0]}
          defaultOptions={optionsResultsYear}
          menuPortalTarget={document.body}
          isDisabled={!!store.strategies.filters.dateResults}
          value={!store.strategies.filters.dateMilestones
            ? optionsResultsYear[0]
            : { value: store.strategies.filters.dateMilestones, label: store.strategies.filters.dateMilestones }}
          onChange={async (e) => {
            await store.strategies.changeFilter('dateMilestones', e.value, requests);
            store.strategies.changeAllTableStatus(true, ['milestones']);
            setAllTablesOpen({ milestones: true, projMilestones: false });
          }}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 100 }),
          }}
        />
      </Form.Group>
      <Form.Group xs="2" className={style.tooltipSelectField}>
        <Form.Label style={{ fontSize: '14px', fontWeight: 600 }}>
          Статус результата/вехи
        </Form.Label>
        <AsyncSelect
          noOptionsMessage={() => 'Ничего не найдено'}
          loadingMessage={() => 'Поиск...'}
          placeholder="Не выбран"
          defaultOptions={optionsResultStatus}
          menuPortalTarget={document.body}
          isMulti
          value={store.strategies.filters.status
            ? store.strategies.filters.status
              .reduce((acc, curr) => (acc.some((status) => statusForFilter[status] === statusForFilter[curr]) ? acc : [...acc, curr]), [])
              .map((status) => optionsResultStatus.find((opt) => opt.value.includes(status)))
            : null}
          onChange={(values) => {
            const statuses = values.reduce((acc, opt) => [...acc, ...opt.value], []);
            store.strategies.changeFilter('status', statuses.length > 0 ? statuses : null, requests);
          }}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 100 }),
            placeholder: (base) => ({ ...base, color: 'black' }),
          }}
        />
      </Form.Group>
      <Form.Group xs="3" className={style.tooltipSelectField} style={{ width: '30%', maxWidth: 450 }}>
        <Form.Label style={{ fontSize: '14px', fontWeight: 600 }}>
          Проекты
        </Form.Label>
        <Select
          placeholder="Не указаны"
          options={projectsOptions}
          menuPortalTarget={document.body}
          isMulti
          value={selectedProjects.map((proj) => projectsOptions.find((opt) => opt.value.id === proj.id))}
          onChange={(values) => {
            const projects = values.map((opt) => opt.value);
            setProjectsFilter(projects);
            store.strategies.changeSyncFilter('projs', projects);
            store.strategies.changeAllTableStatus(true, ['milestones', 'projMilestones']);
            setAllTablesOpen({ milestones: true, projMilestones: true });
          }}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 100 }),
            placeholder: (base) => ({ ...base, color: 'black' }),
            multiValue: (base) => ({ ...base, maxWidth: 100 }),
          }}
        />
      </Form.Group>
      <DownloadLink
        variant="outline-primary"
        url={`/strategies/${projectId}/results/0/export?full=true&${store.strategies.getFilterStr()}`}
        filename={`Выдающиеся результаты СП${projectId}.xlsx`}
        className={style.tooltipButton}
        style={{ marginLeft: 'auto' }}
      >
        Скачать
      </DownloadLink>
      <NavLink
        to={`/${getPathType(type)}/${projectId}/results/new`}
        className={style.tooltipButton}
      >
        {(isAdmin(userCtx) || isStratAdmin(userCtx, stratId)) && (
        <Button
          onClick={() => {
            store.strategies.clearFilters();
            requests.updateAllPlanResults();
          }}
          className={style.tooltipButton}
        >
          + Изменить план
        </Button>
        )}
      </NavLink>
    </div>
  );
}

export default ResultsHeader;
